// Single-quote micro testimonial card — used inline (not in a dedicated section).
// Placement-aware sizing so each instance fits its surrounding density.

export default function TestimonialCard({ quote, name, location, size = "md", className = "" }) {
  const sizes = {
    sm: "max-w-lg px-4 py-3 text-sm",
    md: "max-w-xl px-5 py-4 text-sm sm:text-base",
    lg: "max-w-2xl px-6 py-5 text-base sm:text-lg",
  };
  return (
    <figure
      className={`mx-auto ${sizes[size]} bg-[#0B1D3A]/70 border border-[#C5A059]/35 rounded-sm backdrop-blur-sm ${className}`}
      data-testid="testimonial-card"
    >
      <blockquote className="text-white/95 leading-relaxed text-right" style={{ direction: "rtl" }}>
        <span className="text-[#C5A059] font-display text-2xl leading-none align-top">”</span>
        {quote}
        <span className="text-[#C5A059] font-display text-2xl leading-none align-top">“</span>
      </blockquote>
      <figcaption className="mt-2 text-xs sm:text-sm text-[#C5A059]/80 font-bold text-right">
        — {name}، {location}
      </figcaption>
    </figure>
  );
}
